import React, { useState, useEffect } from "react";
import { Navbar } from "./components/Navbar/Navbar";
import { Content } from "./components/Content/Content";


import "./App.css";

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);



  return (
    <div className="">
      {/* Wavy Background */}
      <div className="wave-header">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#524439"
            fillOpacity="1"
            d="M0,288L60,288C120,288,240,288,360,250.7C480,213,600,139,720,133.3C840,128,960,192,1080,202.7C1200,213,1320,171,1380,149.3L1440,128L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
          ></path>
        </svg>
      </div >
      {/* Navbar */}
      <Navbar />
      <div  className={`transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>

      {/* Content */}
      <Content />

      {/* Footer */}
      <div className="flex justify-center bg sticky bottom-2">
        <button
          className="bg-cBlack rounded-xl px-24 py-4 text-cWhite font-bold text-xl"
          onClick={openModal}
        >
          הזמן עכשיו ב₪97
        </button>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center px-4">
          <div className="bg-cBlack bg-opacity-75 absolute top-0 left-0 w-full h-full"></div>

          <div className="relative bg-cWhite rounded-lg pt-12 pb-8 px-12 ">
            <button
              className="absolute top-0 right-0 m-6 text-cBrownDark font-bold"
              onClick={closeModal}
            >
              X
            </button>
            <div className="text-center mb-4 text-cBrownDark font-bold text-xl">
              איזה כיף! איך תרצה לקבל את הספר?{" "}
            </div>
            <div className="flex flex-col justify-center">
              <a href="https://api.whatsapp.com/send/?phone=972505887298&text=%D7%A9%D7%9C%D7%95%D7%9D,+%D7%91%D7%99%D7%A7%D7%A8%D7%AA%D7%99+%D7%91%D7%90%D7%AA%D7%A8+%D7%94%D7%A1%D7%A4%D7%A8+%D7%95%D7%90%D7%A0%D7%99+%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%A0/%D7%AA+%D7%9C%D7%A8%D7%9B%D7%95%D7%A9+%D7%91%D7%90%D7%9E%D7%A6%D7%A2%D7%95%D7%AA+%D7%90%D7%99%D7%A1%D7%95%D7%A3+%D7%A2%D7%A6%D7%9E%D7%99" className="bg-cBrownDark text-cWhite font-bold py-2 px-4 rounded-lg text-center">
                איסוף עצמי מחולון (בתיאום מראש)
              </a>
              <a href="https://api.whatsapp.com/send/?phone=972505887298&text=%D7%A9%D7%9C%D7%95%D7%9D,+%D7%91%D7%99%D7%A7%D7%A8%D7%AA%D7%99+%D7%91%D7%90%D7%AA%D7%A8+%D7%94%D7%A1%D7%A4%D7%A8+%D7%95%D7%90%D7%A0%D7%99+%D7%9E%D7%A2%D7%95%D7%A0%D7%99%D7%99%D7%A0/%D7%AA+%D7%9C%D7%A8%D7%9B%D7%95%D7%A9+%D7%91%D7%90%D7%9E%D7%A6%D7%A2%D7%95%D7%AA+%D7%9E%D7%A9%D7%9C%D7%95%D7%97&" className="bg-cBrownDark text-cWhite font-bold py-2 px-4 rounded-lg mt-2 text-center">
                משלוח בתוספת 25 ש״ח
              </a>
            </div>
            <div className="text-xs text-center mt-2 px-2">
              ההזמנות מתבצעות דרך הווטסאפ, בלחיצה על אחת הדרכים תועבר ישירות לווטסאפ להמשך טיפול
              </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default App;
